export type IGetAllHearingTypeByCustomerIdParams = {
  customerId: number;
  active: boolean;
};

export interface IGetAllPermissionByCustomerIdAndProfileId {
  customerId: number;
  profileId: number;
}

export type IGetAllAttendantByHearingTypeIdParams = {
  procedureCustomerId: number;
  hearingTypeId: number;
};

// autenticação
const auth = {
  signIn: "/v1/UserCustomerAuthentication/CheckCredentials",
};

// perfís
const profile = {
  getUserCustomerProfileByPlace: (customerId: number) =>
    `/v1/UserCustomerProfile/GetUserCustomerProfileByUserCustomerId?UserCustomerId=${customerId}`,
};

// audiencias
const audiences = {
  getListByPlaceId: (placeId: number) =>
    `/v1/Hearing/GetAllByFilters?placeId=${placeId}&active=true`,
  getAllByFilters: `/v1/Hearing/GetAllByFilters`,
  getAllByFiltersV2: `/v1/Hearing/GetAllByFiltersV2`,
  migrateDataToAnotherHearing: `/v1/Hearing/SwapHearingInformation`,
};

// Audiencias gravadas
const recordedAudiences = {
  getListByAudienceId: (audienceId: number) =>
    `/v1/Hearing/GetAllHearingInformationsByHearingId?hearingId=${audienceId}`,
};

// Requisição com passos para criar uma nova gravação de audiencia
const audienceRecord = {
  GetAllHearingTypeByCustomerId: ({
    customerId,
    active,
  }: IGetAllHearingTypeByCustomerIdParams) =>
    active !== undefined
      ? `/v1/HearingType/GetAllByCustomerId?customerId=${customerId}&active${
          active ? 1 : 0
        }`
      : `/v1/HearingType/GetAllByCustomerId?customerId=${customerId}`,
  GetAllAttendantByHearingId: ({
    procedureCustomerId,
    hearingTypeId,
  }: IGetAllAttendantByHearingTypeIdParams) =>
    `/v1/Attedant/GetAllByHearingType?procedureCustomerId=${procedureCustomerId}&hearingTypeId=${hearingTypeId}`,
  createAudienceRecord: "v1/HearingFile/Add",
};

// Certificate
const customerCertificate = {
  importCustomerCertificateImport: `/v1/CustomerCertificate/Import`,
  addCustomerCertificate: `/v1/CustomerCertificate/Add`,
  getCustomerCertificateByCustomerId: (customerId: number) =>
    `/v1/CustomerCertificate/GetByCustomerId?customerId=${customerId}`,
};

// UserCustomerAuthentication
const userCustomerAuthentication = {
  forgotPassword: `/v1/UserCustomerAuthentication/ForgotPassword`,
  changePassword: `/v1/UserCustomerAuthentication/ChangePassword`,
};

// UserCustomer
const userCustomer = {
  getUserCustomerById: (id: number) => `/v1/UserCustomer/Get?id=${id}`,
  putUserCustomerByBody: `/v1/UserCustomer/Update`,
  uploadPhoto: (userId: number) =>
    `/v1/UserCustomer/UploadPhoto?userId=${userId}`,
};

// SystemNotification
const systemNotification = {
  getAllByUser: (userId: number) =>
    `/v1/SystemNotification/GetAllByUserId?userId=${userId}`,
  add: `/v1/SystemNotification/Add`,
  setReaded: (notificationId: number) =>
    `/v1/SystemNotification/Update?id=${notificationId}`,
  setReadedAll: `/v1/SystemNotification/UpdateAll`,
};

// HearingFile
const hearingFile = {
  getAllDownloadsByHearingId: (hearingId: number) =>
    `v1/HearingFile/GetAllDownloadsByHearingId?hearingId=${hearingId}`,
  deleteByObject: `/v1/HearingFile/DeleteObject`,
  deleteById: (hearingFileId: number) =>
    `/v1/HearingFile/Delete?id=${hearingFileId}`,
  upload: `/v1/HearingFile/Update`,
  patch: (id: number) => `/v1/HearingFile/Update?id=${id}`,
  add: `/v1/HearingFile/Add`,
  uploadLargeFileStream: `/v1/HearingFile/UploadLargeFileStream`,
};

const hearingTranscription = {
  createTranscription: "/v1/HearingTranscription/Add",
  getAllByHearingFileId: (hearingFileId: number) =>
    `/v1/HearingTranscription/GetAllByHearingFileId?hearingFileId=${hearingFileId}`,
};

const permissions = {
  getAllPermissionByCustomerIdAndProfileId: ({
    customerId,
    profileId,
  }: IGetAllPermissionByCustomerIdAndProfileId) =>
    `/v1/SystemObjectUserCustomerProfile/GetAllByObjectsUserCustomerProfile?customerId=${customerId}&UserCustomerProfileId=${profileId}`,
};

export const routers_constants = {
  auth,
  profile,
  audiences,
  recordedAudiences,
  audienceRecord,
  customerCertificate,
  userCustomerAuthentication,
  userCustomer,
  systemNotification,
  hearingFile,
  hearingTranscription,
  permissions,
};
